import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Performance optimization - Use production mode for React
if (process.env.NODE_ENV === 'production') {
  // This helps with performance in production builds
  // React will strip out development-only code
}
render(<App data-id="element-844" />, document.getElementById('root'));